import React, { useState } from "react";
import { AutoComplete, Input } from "antd";

const DynamicDropdown = (props) => {
  const { setOptions, options, setEventType, value } = props;
  const [val, setVal] = useState(value || "");
  const [dataSource, setDataSource] = useState(options);

  const onSearch = (searchText) => {
    if (!searchText) {
      setDataSource(options);
      return;
    }

    const filtered = options.filter((opt) =>
      opt.toLowerCase().includes(searchText.toLowerCase()),
    );

    if (!options.includes(searchText)) {
      filtered.push(`Add ${searchText}`);
    }

    setDataSource(filtered);
  };

  const onSelect = (selected) => {
    let finalValue = selected;
    if (selected.startsWith("Add ")) {
      finalValue = selected.split("Add ")[1];
      setOptions([...options, finalValue]);
    }

    setEventType(finalValue);
    setVal(finalValue);
  };

  const onChange = (inputValue) => {
    setVal(inputValue); // Update local state
    setEventType(inputValue); // Keep selected event type in sync
  };

  return (
    <div style={{ width: 300 }}>
      <AutoComplete
        value={val}
        options={dataSource.map((item) => ({ value: item }))}
        onSelect={onSelect}
        onSearch={onSearch}
        onChange={onChange}
        allowClear
        style={{ width: "100%" }}
      >
        <Input placeholder="Categories" />
      </AutoComplete>
    </div>
  );
};

export default DynamicDropdown;
